import { createFileRoute } from "@tanstack/react-router"
import { StoriesPage, meta } from "@/content"

export const Route = createFileRoute("/(public)/stories/")({
  component: RouteComponent,
  head: () => ({ meta: meta({ title: "Stories" }) }),
})

function RouteComponent() {
  return <StoriesPage />
}
